module.exports = __webpack_public_path__ + "static/media/DAI_USDT_Biswap.77545eb0.png";